export default "__VITE_PUBLIC_ASSET__9cf74f84__"